import type { FriendsResponse, LeagueResponse } from "@newfungame/contracts";

export interface LeagueActions {
  /** Данные окна лиги; `null` — не загрузились. */
  league(): Promise<LeagueResponse | null>;
  friends(): Promise<FriendsResponse | null>;
  /** Забрать кристаллы за неделю. */
  claimLeague(): void | Promise<void>;
  /** Отправить ссылку-приглашение (`app/share.ts`). */
  inviteFriend(url: string, place?: "boss" | "league"): void;
}

const noop = () => {};

export const defaults: LeagueActions = {
  league: async () => null,
  friends: async () => null,
  claimLeague: noop,
  inviteFriend: noop,
};

declare module "../actions" {
  interface WindowActions extends LeagueActions {}
}
